import { useMemo } from 'react'

import {
  getIsScenarioNameValid,
  getScenarioNameErrorMessage
} from './textValidations'

const useOnCreateValidator = (
  scenarioName: string,
  existingNames: string[],
  isScenarioNameEmpty: boolean
): [boolean, string] => {
  return useMemo(() => {
    const isUniqueScenario = !existingNames?.some(
      (scenarioOption) =>
        scenarioName.toLowerCase() === scenarioOption.toLowerCase()
    )

    let isScenarioNameValid = getIsScenarioNameValid(
      scenarioName,
      isUniqueScenario
    )

    const scenarioNameErrorMessage = getScenarioNameErrorMessage(
      scenarioName,
      isScenarioNameEmpty,
      isUniqueScenario
    )

    isScenarioNameValid = isScenarioNameValid && !isScenarioNameEmpty

    return [isScenarioNameValid, scenarioNameErrorMessage]
  }, [existingNames, isScenarioNameEmpty, scenarioName])
}

export { useOnCreateValidator }
